import React from 'react';
import { Trans } from 'react-i18next';
import { SongInsights } from '../../Dashboard';
import { getStationNameList } from '../SmartInsightsCardContentHelper';

// 5. Genre card content logic
export const getGenreCardContent = (
  songInsights: SongInsights,
  isHovering = false
): React.ReactNode => {
  if (isHovering) {
    return <Trans i18nKey="GENRE_HOVER" components={{ bold: <strong /> }} />;
  }
  const genres = songInsights?.songInsightsData?.top_genres;
  if (genres) {
    const { items, last } = getStationNameList(genres.map((g) => g.name));
    if (genres.length > 0) {
      if (genres.length === 1) {
        return (
          <Trans
            i18nKey="GENRE_SINGLE"
            values={{ genre: last }}
            components={{ bold: <strong /> }}
          />
        );
      }
      if (genres.length >= 2) {
        return (
          <Trans
            i18nKey="GENRE_MULTI"
            values={{
              genrelist: items,
              lastGenre: last,
            }}
            components={{ bold: <strong /> }}
          />
        );
      }
    }
  }
  return null;
};
